import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const WinterMarket = {
  id: "36",
  name: "Winter Market",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Winter_Market",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Winter_Market',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          10, 15, 15, 23, 23, 29, 29, 29, 37, 37, 37, 37, 47, 47, 51, 51, 55, 55,
          59, 59, 62, 62, 66, 66, 66, 71, 71, 74, 74, 74, 78, 78, 81, 81, 84, 84,
          87, 87, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116,
          118, 120, 122, 124, 126, 128, 130, 132,
        ],
        bronzeAge: [
          15, 28, 28, 43, 43, 55, 55, 55, 70, 70, 70, 70, 87, 87, 95, 95, 103,
          103, 110, 110, 117, 117, 123, 123, 123, 132, 132, 138, 138, 138, 147,
          147, 153, 153, 158, 158, 164, 164, 169, 213, 218, 223, 228, 233, 238,
          243, 248, 253, 258, 263, 268, 273, 278, 283, 288, 293, 298, 303, 308,
          313,
        ],
        minoanEra: [
          25, 42, 42, 63, 63, 81, 81, 81, 103, 103, 103, 103, 128, 128, 140, 140,
          151, 151, 161, 161, 171, 171, 180, 180, 180, 194, 194, 203, 203, 203,
          216, 216, 224, 224, 232, 232, 240, 240, 248, 254, 260, 266, 272, 278,
          284, 290, 296, 302, 308, 314, 320, 326, 332, 338, 344, 350, 356, 362,
          368, 374,
        ],
        classicGreece: [
          30, 55, 55, 83, 83, 106, 106, 106, 135, 135, 135, 135, 169, 169, 184,
          184, 198, 198, 212, 212, 225, 225, 238, 238, 238, 256, 256, 268, 268,
          268, 285, 285, 295, 295, 306, 306, 316, 316, 327, 335, 343, 351, 359,
          367, 375, 383, 391, 399, 407, 415, 423, 431, 439, 447, 455, 463, 471,
          479, 487, 495,
        ],
        earlyRome: [
          40, 68, 68, 103, 103, 132, 132, 132, 168, 168, 168, 168, 210, 210, 228,
          228, 246, 246, 263, 263, 280, 280, 295, 295, 295, 318, 318, 332, 332,
          332, 353, 353, 367, 367, 380, 380, 393, 393, 405, 420, 430, 440, 450,
          460, 470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590,
          600, 610, 620,
        ],
        romanEmpire: [
          50, 81, 81, 123, 123, 157, 157, 157, 201, 201, 201, 201, 250, 250, 273,
          273, 294, 294, 315, 315, 334, 334, 353, 353, 353, 380, 380, 397, 397,
          397, 422, 422, 438, 438, 454, 454, 469, 469, 484, 496, 508, 520, 532,
          544, 556, 568, 580, 592, 604, 616, 628, 640, 652, 664, 676, 688, 700,
          712, 724, 736,
        ],
        byzantineEra: [
          55, 95, 95, 144, 144, 183, 183, 183, 234, 234, 234, 234, 291, 291, 317,
          317, 342, 342, 366, 366, 388, 388, 410, 410, 410, 441, 441, 462, 462,
          462, 491, 491, 509, 509, 528, 528, 546, 546, 563, 578, 592, 606, 620,
          634, 648, 662, 676, 690, 704, 718, 732, 746, 760, 774, 788, 802, 816,
          830, 844, 858,
        ],
        ageOfTheFranks: [
          65, 108, 108, 164, 164, 209, 209, 209, 266, 266, 266, 266, 332, 332,
          365, 365, 390, 390, 417, 417, 443, 443, 468, 468, 468, 503, 503, 526,
          526, 526, 559, 559, 581, 581, 601, 601, 622, 622, 642, 658, 674, 690,
          706, 722, 738, 754, 770, 786, 802, 818, 834, 850, 866, 882, 898, 914,
          930, 946, 962, 978,
        ],
        feudalAge: [
          70, 120, 120, 183, 183, 233, 233, 233, 297, 297, 297, 297, 370, 370,
          404, 404, 435, 435, 465, 465, 494, 494, 522, 522, 522, 562, 562, 587,
          587, 587, 624, 624, 648, 648, 671, 671, 694, 694, 716, 734, 752, 770,
          788, 806, 824, 842, 860, 878, 896, 914, 932, 950, 968, 986, 1004, 1022,
          1040, 1058, 1076, 1094,
        ],
        iberianEra: [
          77, 132, 132, 201, 201, 256, 256, 256, 327, 327, 327, 327, 407, 407,
          444, 444, 479, 479, 512, 512, 543, 543, 574, 574, 574, 618, 618, 646,
          646, 646, 686, 686, 713, 713, 738, 738, 763, 763, 788, 810, 830, 850,
          870, 890, 910, 930, 950, 970, 990, 1010, 1030, 1050, 1070, 1090, 1110,
          1130, 1150, 1170, 1190, 1210,
        ],
        kingdomOfSicily: [
          85, 145, 145, 221, 221, 282, 282, 282, 360, 360, 360, 360, 448, 448,
          488, 488, 527, 527, 563, 563, 597, 597, 631, 631, 631, 680, 680, 711,
          711, 711, 755, 755, 784, 784, 812, 812, 839, 839, 867, 890, 912, 934,
          956, 978, 1000, 1022, 1044, 1066, 1088, 1110, 1132, 1154, 1176, 1198,
          1220, 1242, 1264, 1286, 1308, 1330,
        ],
        highMiddleAges: [
          94, 160, 160, 243, 243, 310, 310, 310, 396, 396, 396, 396, 493, 493,
          537, 537, 580, 580, 619, 619, 657, 657, 694, 694, 694, 748, 748, 782,
          782, 782, 831, 831, 862, 862, 893, 893, 923, 923, 954, 970, 994, 1018,
          1042, 1066, 1090, 1114, 1138, 1162, 1186, 1210, 1234, 1258, 1282, 1306,
          1330, 1354, 1378, 1402, 1426, 1450,
        ],
        earlyGothicEra: [
          96, 164, 164, 251, 251, 322, 322, 322, 414, 414, 414, 414, 519, 519,
          567, 567, 614, 614, 657, 657, 699, 699, 740, 740, 740, 800, 800, 838,
          838, 838, 893, 893, 928, 928, 963, 963, 997, 997, 1032, 1050, 1076,
          1102, 1128, 1154, 1180, 1206, 1232, 1258, 1284, 1310, 1336, 1362, 1388,
          1414, 1440, 1466, 1492, 1518, 1544, 1570,
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4
      ]),
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 5
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          8,8,15,15,20,20,20,27,27,27,33,33,33,38,38,41,41,44,44,47,47,50,50,53,53,53,56,56,59,59,59,62,62,65,65,67,67,69,69,69,72,74,75,77,78,80,81,83,84,86,87,89,90,92,93,95,96,98,99,101
        ],
        bronzeAge: [
          8,8,15,15,20,20,20,27,27,27,33,33,33,38,38,41,41,44,44,47,47,50,50,53,53,53,56,56,59,59,59,62,62,65,65,67,67,69,69,69,72,74,75,77,78,80,81,83,84,86,87,89,90,92,93,95,96,98,99,101
        ],
        minoanEra: [
          11,11,21,21,29,29,29,38,38,38,46,46,46,53,53,58,58,62,62,66,66,70,70,74,74,74,79,79,82,82,82,87,87,91,91,94,94,97,97,97,101,103,105,107,109,111,113,115,117,119,121,123,125,127,129,131,133,135,137,139
        ],
        classicGreece: [
          18,18,34,34,46,46,46,61,61,61,74,74,74,85,85,93,93,99,99,106,106,112,112,118,118,118,127,127,132,132,132,140,140,146,146,151,151,156,156,156,163,167,170,174,177,181,184,188,191,195,198,202,205,209,212,216,219,223,226,230
        ],
        earlyRome: [
          21,21,41,41,56,56,56,75,75,75,90,90,90,104,104,113,113,122,122,129,129,137,137,144,144,144,155,155,162,162,162,172,172,178,178,184,184,190,190,190,199,204,208,213,217,222,226,231,235,240,244,249,253,258,262,267,271,276,280,285
        ],
        romanEmpire: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        byzantineEra: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        ageOfTheFranks: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        feudalAge: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        iberianEra: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        kingdomOfSicily: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        highMiddleAges: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        earlyGothicEra: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        lateGothicEra: [
          25,25,49,49,67,67,67,88,88,88,107,107,107,123,123,134,134,144,144,153,153,162,162,171,171,171,183,183,191,191,191,203,203,210,210,218,218,225,225,225,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ]
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
  ]),
};

export default WinterMarket;
